import { Link } from "react-router-dom";
import { GLOSSARY_SEO } from "../../seo/explore-data";
import { PageSeo, Crumbs, CtaBlock } from "./ExploreBits";

export default function Glossary() {
  const terms = Object.entries(GLOSSARY_SEO).sort((a, b) => a[0].localeCompare(b[0]));
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid="glossary-page">
      <PageSeo title="Indian Power Project Regulatory Glossary — CTU, GNA, CEIG, PTCC & more | RegNav"
        description={`Plain-language definitions of ${terms.length}+ Indian power-sector regulatory terms: ${terms.slice(0, 8).map(([t]) => t).join(", ")} and more.`}
        path="/glossary/" />
      <Crumbs items={[{ name: "Home", to: "/" }, { name: "Glossary" }]} />
      <h1 className="font-serif text-3xl sm:text-4xl text-[#0B1F3A]">Regulatory glossary for Indian power projects</h1>
      <p className="text-sm text-[#475569] mt-3 max-w-2xl">Every acronym you'll meet on the road to commissioning — defined in plain language by Solarian's regulatory experts.</p>
      <dl className="mt-8">
        {terms.map(([t, d]) => (
          <div key={t} className="border-b border-[#0B1F3A]/8 py-3">
            <dt className="font-bold text-[#0B1F3A] text-sm">{t}</dt>
            <dd className="text-sm text-[#475569] mt-0.5">{d}</dd>
          </div>
        ))}
      </dl>
      <p className="text-sm text-[#475569] mt-8">
        Deep dives: <Link to="/approvals" className="text-[#1D4ED8] hover:underline">all approvals</Link> · <Link to="/states" className="text-[#1D4ED8] hover:underline">state roadmaps</Link>
      </p>
      <CtaBlock />
    </div>
  );
}
